// Vendor JS
import Debug from 'debug';

// Custom JS
import ForgotPassword from '../common/forgot-password';

/* eslint-disable no-new */ // Allow using the new keyword while not assigning the class to a variable

/**
 * To be fired on the /login page
 */
export default {
	init() {
		try {
			Debug(`cig:info:sage:route:login`)(`init start`);

			new ForgotPassword();

		} catch (err) {
			Debug(`cig:error:sage:route:login`)(`Login Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:login`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:login`)(`Login Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
